import angular from "angular";
import template from "./admin-settings-policies-courses.html";
import AdminSettingsPoliciesCoursesController from "./admin-settings-policies-courses.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.settings.policies.courses", {
    url: "/courses",
    controller: AdminSettingsPoliciesCoursesController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.owner,
        USER_ROLES.administrator,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.settings.policies.courses", [])
  .config(config)
  .controller(
    "AdminSettingsPoliciesCoursesController",
    AdminSettingsPoliciesCoursesController,
  );
